import type { TreePassThroughMethodOptions } from 'primevue/tree';

export default {
  tree: {
    wrapper: {
      class: 'overflow-visible'
    },
    nodeContent: (options: TreePassThroughMethodOptions) => {
      return {
        id: 'node-' + options.context.node.key,
        class: 'w-full text-sm font-primary h-[18px]'
      };
    },
    mask: 'bg-transparent h-[0px]',
    loadingIcon: 'absolute top-0 right-0 text-yellow-600 w-[15px] h-[15px]'
  },
  datatable: {
    root: {
      class: 'font-primary border-l-0 border-r-0 text-sm'
    },
    bodyRow: {
      class: 'text-sm custom-datatable-row'
    },
    mask: {
      class: 'bg-blue-200 opacity-50 text-blue-900'
    },
    table: 'border-b-0',
    emptyMessage: 'bg-transparent',
    emptyMessageCell: 'border-b-0'
  },
  column: {
    columnTitle: {
      class: 'text-xs font-normal uppercase'
    },
    bodyCell: {
      class: 'px-2 py-2'
    },
    headerCell: {
      class: 'px-2 py-2'
    },
    pcRowCheckbox: {
      root: '!align-middle table-cell',
      box: 'border-4',
      icon: {
        class: 'opacity-0'
      }
    }
  },
  checkbox: {
    root: '!align-middle table-cell',
    box: 'border-4',
    icon: {
      class: 'opacity-0'
    }
  },
  listbox: {
    root: 'border-blue-300',
    list: 'p-0'
  },
  dialog: {
    root: 'p-[40px] text-sm',
    header: 'font-secondary mb-[20px]',
    footer: 'mt-[20px] p-0',
    content: 'font-primary'
  },
  button: {
    root: 'font-secondary'
  },
  breadcrumb: {
    list: 'flex',
    item: 'truncate grow-1/8 max-w-[100px] last:max-w-[300px]'
  },
  multiSelect: {
    root: 'text-[13px]',
    optionLabel: 'text-[12px]'
  },
  autocomplete: {
    pcInputText: '!border-0'
  },
  Select: {
    emptyMessage: 'text-sm'
  },
  tooltip: {
    text: 'font-primary'
  },
  ConfirmPopup: {
    root: 'text-sm'
  },
  paginator: {
    first: 'bg-blue-100',
    last: 'bg-blue-100',
    prev: 'bg-blue-100',
    next: 'bg-blue-100'
  },
  toast: {
    root: 'font-primary',
    message: {
      class: 'border-l-4 shadow-sm flex items-start'
    },
    messageContent: {
      class: 'py-3 px-4 flex-1'
    },
    summary: {
      class: 'font-secondary text-sm font-medium'
    },
    detail: {
      class: 'font-primary text-xs mt-1'
    },
    closeButton: {
      class: 'hover:bg-blue-100 rounded shrink-0 mr-2 mt-2'
    }
  }
};
